/**
 * @generated SignedSource<<8830d8c0bed5a69377356c0a774119ed>>
 * @relayHash 6416f0e9ed30a12a61eecd6a4a661c18
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fa83058523b4afd93c8ed56f4d2de7d706da3719dd2e00f19f2f80256b7afc85

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectNotificationConfigurationState = "CONFIGURED" | "DEFAULT" | "%future added value";
export type JiraProjectSortField = "CATEGORY" | "FAVOURITE" | "KEY" | "LAST_ISSUE_UPDATED_TIME" | "LEAD" | "NAME" | "RECOMMENDATION" | "%future added value";
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type SortDirection = "ASC" | "DESC" | "%future added value";
export type JiraProjectFilterInput = {
  keyword?: string | null;
  notificationConfigurationState?: JiraProjectNotificationConfigurationState | null;
  projectCategoryId?: string | null;
  sortBy?: JiraProjectSortInput | null;
  types?: ReadonlyArray<JiraProjectType> | null;
};
export type JiraProjectSortInput = {
  order?: SortDirection | null;
  sortBy?: JiraProjectSortField | null;
};
export type ProjectDirectoryLayoutQuery$variables = {
  cloudId: string;
  filter: JiraProjectFilterInput;
  first?: number | null;
  includeCsmLandingModal: boolean;
  isAdminSettingsContext: boolean;
  isAnonymous: boolean;
  last?: number | null;
};
export type ProjectDirectoryLayoutQuery$data = {
  readonly jira: {
    readonly canBrowseProjects: {
      readonly hasPermission: boolean | null;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"EmptyView" | "Header" | "NoPermissionViews" | "ProjectDirectoryLayout" | "ProjectsList130BadPattern" | "RefinementBar">;
};
export type ProjectDirectoryLayoutQuery = {
  response: ProjectDirectoryLayoutQuery$data;
  variables: ProjectDirectoryLayoutQuery$variables;
};
({
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
  "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
} as {
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider: {
    readonly get: () => boolean;
  };
});

import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';
import isAllowingEndUsersToAccessCustomTemplates_provider from '@jira/platform__graphql-relay-provider/src/jira-custom-template-allow-end-users-to-create-custom-templates.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCsmLandingModal"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAdminSettingsContext"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAnonymous"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v7 = [
  {
    "kind": "Variable",
    "name": "isAnonymous",
    "variableName": "isAnonymous"
  }
],
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "alias": "canBrowseProjects",
  "args": [
    (v8/*: any*/),
    {
      "kind": "Literal",
      "name": "type",
      "value": "BROWSE_PROJECTS"
    }
  ],
  "concreteType": "JiraPermission",
  "kind": "LinkedField",
  "name": "permission",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasPermission"
    }
  ]
},
v10 = [
  (v8/*: any*/)
],
v11 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
},
v13 = {
  "kind": "ScalarField",
  "name": "name"
},
v14 = {
  "kind": "ScalarField",
  "name": "key"
},
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v17 = [
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectDirectoryLayoutQuery",
    "selections": [
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "Header"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "RefinementBar"
      },
      {
        "args": (v7/*: any*/),
        "kind": "FragmentSpread",
        "name": "ProjectsList130BadPattern"
      },
      {
        "args": [
          {
            "kind": "Variable",
            "name": "includeCsmLandingModal",
            "variableName": "includeCsmLandingModal"
          },
          {
            "kind": "Variable",
            "name": "isAdminSettingsContext",
            "variableName": "isAdminSettingsContext"
          }
        ],
        "kind": "FragmentSpread",
        "name": "ProjectDirectoryLayout"
      },
      {
        "kind": "FragmentSpread",
        "name": "EmptyView"
      },
      {
        "kind": "FragmentSpread",
        "name": "NoPermissionViews"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v9/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "ProjectDirectoryLayoutQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "alias": "canCreateProject",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "type",
                "value": "CREATE_PROJECT"
              }
            ],
            "kind": "ScalarField",
            "name": "canPerform"
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraWorkManagementLicensing",
            "kind": "LinkedField",
            "name": "jwmLicensing",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "currentUserSeatEdition"
              }
            ]
          },
          {
            "args": [
              (v8/*: any*/),
              {
                "kind": "Variable",
                "name": "filter",
                "variableName": "filter"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "last",
                "variableName": "last"
              }
            ],
            "concreteType": "JiraProjectConnection",
            "kind": "LinkedField",
            "name": "allJiraProjects",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "canViewIssue",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_ISSUES"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                      },
                      (v12/*: any*/),
                      (v13/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectId"
                      },
                      (v14/*: any*/),
                      {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "medium"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "defaultNavigationItem",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "url"
                              }
                            ],
                            "type": "JiraNavigationItem",
                            "abstractKey": "__isJiraNavigationItem"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v12/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "concreteType": "JiraProjectCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v13/*: any*/),
                          (v12/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lead",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isUser"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "accountId"
                          },
                          (v13/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "picture"
                          },
                          (v12/*: any*/),
                          {
                            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "appType"
                                  }
                                ],
                                "type": "AppUser"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "projectUrl"
                      },
                      {
                        "alias": "canViewProjectConfig",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "type",
                            "value": "VIEW_PROJECT_CONFIG"
                          }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": "action(type:\"VIEW_PROJECT_CONFIG\")"
                      },
                      {
                        "alias": "jiraProjectType",
                        "kind": "ScalarField",
                        "name": "projectType"
                      },
                      {
                        "alias": "jiraProjectName",
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "condition": "isAdminSettingsContext",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": "lastUpdatedToolTipDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "format",
                                "value": "COMPLETE_DATETIME_FORMAT"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "lastUpdatedFormatted",
                            "storageKey": "lastUpdatedFormatted(format:\"COMPLETE_DATETIME_FORMAT\")"
                          },
                          {
                            "alias": "lastUpdatedDisplayDate",
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "format",
                                "value": "RELATIVE"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "lastUpdatedFormatted",
                            "storageKey": "lastUpdatedFormatted(format:\"RELATIVE\")"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              (v16/*: any*/),
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  }
                ]
              },
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isHasTotal"
              }
            ]
          },
          {
            "alias": "canContactAdmin",
            "args": [
              (v8/*: any*/),
              {
                "kind": "Literal",
                "name": "keys",
                "value": "jira.show.contact.administrators.form"
              }
            ],
            "concreteType": "JiraApplicationProperty",
            "kind": "LinkedField",
            "name": "applicationPropertiesByKey",
            "plural": true,
            "selections": [
              (v14/*: any*/),
              {
                "kind": "ScalarField",
                "name": "value"
              },
              (v12/*: any*/)
            ]
          },
          (v9/*: any*/),
          {
            "condition": "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "shouldDisplay",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_PROJECT_CREATION_ENTRY"
                  }
                ],
                "kind": "ScalarField",
                "name": "canPerform"
              }
            ]
          },
          {
            "condition": "isAnonymous",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraUserPreferences",
                "kind": "LinkedField",
                "name": "userPreferences",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "projectListRightPanelState"
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__id"
                      }
                    ]
                  }
                ]
              },
              {
                "alias": "sidebarExperimentTemplates",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "experimentKey",
                    "value": "sidebarExperiment"
                  }
                ],
                "concreteType": "JiraProjectListViewTemplateConnection",
                "kind": "LinkedField",
                "name": "projectListViewTemplates",
                "plural": false,
                "selections": (v17/*: any*/)
              },
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectCategoryConnection",
                "kind": "LinkedField",
                "name": "allJiraProjectCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "condition": "includeCsmLandingModal",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "csmJiraProjects",
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "types": [
                        "CUSTOMER_SERVICE"
                      ]
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 0
                  }
                ],
                "concreteType": "JiraProjectConnection",
                "kind": "LinkedField",
                "name": "allJiraProjects",
                "plural": false,
                "selections": (v17/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "condition": "isAnonymous",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraProjectCategoryConnection",
                "kind": "LinkedField",
                "name": "allJiraProjectCategories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraProjectCategoryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "concreteType": "JiraProjectCategory",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v10/*: any*/),
            "concreteType": "JiraProjectTypeDetailsConnection",
            "kind": "LinkedField",
            "name": "allJiraProjectTypes",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectTypeDetailsEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectTypeDetails",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v14/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fa83058523b4afd93c8ed56f4d2de7d706da3719dd2e00f19f2f80256b7afc85",
    "metadata": {},
    "name": "ProjectDirectoryLayoutQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcjiracustomtemplateallowenduserstocreatecustomtemplatesrelayprovider": isAllowingEndUsersToAccessCustomTemplates_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};
})();

(node as any).hash = "1c65a7871b4244d17b4d0d36831c2d34";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
